<template>
    <div>
        <b-card no-body>
            <b-card-body>

                <b-form @keyup.enter="load">
                    <b-col>
                        <b-card bg-variant="light">

                            <b-row>
                                <b-col lg="4" sm="12" class="text-left">
                                    <LgFinderPageEmpresa @input="mudarEmpresa" :prefix='[prefix, title]'
                                        v-model="form.empresa" id="finderPageEmpresa" label="Empresa:" required />

                                </b-col>

                                <b-col cols="2">
                                    <lg-form-date description="" v-model="form.dtInicial" typeDatepicker="date"
                                        label="Data Inicial:" />

                                </b-col>

                                <b-col cols="2">
                                    <lg-form-date description="" v-model="form.dtFinal" typeDatepicker="date"
                                        label="Data Final:" />

                                </b-col>

                                <b-col cols="1">
                                    <b-button v-if="temPrivilegioCriacao()" id="btnAdicionarApoliceIBP"
                                        class=" mr-2 my-2" size="sm" style="height: 20px;" pill variant="primary"
                                        @click="showModal">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="plus" />
                                        </div>
                                    </b-button>
                                    <b-tooltip target="btnAdicionarApoliceIBP" title="Adicionar novo..."
                                        triggers="hover"></b-tooltip>

                                </b-col>


                            </b-row>

                            <b-row>
                                <b-col lg="2" sm="12" class="text-left">
                                    <lg-form-input-number invalidFeedback="O valor deve ser informado!" description=" "
                                        v-model="form.numero" label="Nº Apólice:*" :precision="{ min: 0, max: 0 }" />

                                </b-col>

                                <b-col lg="4" sm="12" class="text-left">
                                    <lg-form-input invalidFeedback="Informe o a descrição" description=""
                                        v-model="form.descricao" label="Descrição:" maxlength="200" />
                                </b-col>

                            </b-row>
                            <b-row>
                                <b-col lg="2" sm="12" class="text-left">
                                    <lg-form-const-select label="Situação:" @change="load" v-model="form.situacao"
                                        :options="form.optionsFilterSituacao" />
                                </b-col>

                                <b-col cols="2" class="text-right">
                                    <b-button id="apagarApoliceIBP" class="mr-2 my-2" size="sm" style="height: 20px"
                                        pill variant="primary" @click="clearForm">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="eraser" />
                                        </div>
                                        <b-tooltip target="apagarApoliceIBP" title="Limpar"></b-tooltip>

                                    </b-button>
                                    <b-button id="localizarApoliceIBP" class="mr-2 my-2" size="sm" style="height: 20px"
                                        pill variant="primary" @click="load">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="search" />
                                        </div>
                                    </b-button>
                                    <b-tooltip target="localizarApoliceIBP" title="Localizar"></b-tooltip>

                                </b-col>


                            </b-row>

                        </b-card>
                        <b-card bg-variant="light">

                            <b-row class="col-12">
                                <b-table id="t-pessoas" class="col-12" responsive="sm" stacked="sm" small outlined
                                    sticky-header show-empty :busy="this.busy" :items="this.records"
                                    :fields="itensFields">

                                    <template #table-busy>
                                        <div class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                        </div>
                                    </template>


                                    <template #empty>
                                        <h6 style="text-align: center">
                                            Nenhum item vinculado
                                        </h6>
                                    </template>

                                    <template v-slot:cell(situacao)="row">
                                        <div :id="row.index + 'switchGrupo-apolice'">
                                            <b-form-checkbox :disabled="!temPrivilegioEdicao()"
                                                v-model="row.item.situacao" @change="alteraSituacao(row.item)"
                                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                                            <b-tooltip :target="row.index + 'switchGrupo-apolice'"
                                                title="Ativar/Desativar..."></b-tooltip>
                                        </div>
                                    </template>
                                    <template v-slot:cell(editar)="row">
                                        <b-button :disabled="!temPrivilegioEdicao()"
                                            :id="row.index + 'edit-button-apolice'" class="my-2" size="sm" pill
                                            variant="primary" @click="editar(row.item)">
                                            <b-icon icon="pencil-square" />
                                            <b-tooltip :target="row.index + 'edit-button-apolice'"
                                                title="Editar..."></b-tooltip>
                                        </b-button>
                                    </template>




                                    <template #head()="data">
                                        <h6>{{ data.label.toUpperCase() }}</h6>
                                    </template>
                                </b-table>
                                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                        <b-col cols="6"
                                            style="display: flex; align-items: center; font-size: 12px">Página
                                            {{ page }} de {{
                                                totalPage }} -
                                            {{ total }} registros</b-col>
                                        <b-col cols="6"
                                            style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                            <b-form-select size="sm" v-model="perPage" @change="load"
                                                :options="perPageOptions">
                                            </b-form-select>
                                        </b-col>
                                    </b-col>
                                    <b-col cols="6">
                                        <div class="d-flex justify-content-end align-items-end">
                                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                                :per-page="perPage" :total-rows="total"></b-pagination>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-row>
                        </b-card>

                    </b-col>
                </b-form>
            </b-card-body>
        </b-card>

        <ModalModalApoliceSeguroIBPAdicionar :prefix="prefix + ' > ' + title + ' > '" :id="id" :idApolice="idApolice"
            v-if="mostrarModal" @fecharModal="fecharModal">
        </ModalModalApoliceSeguroIBPAdicionar>
    </div>
</template>
<script>

import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"

import ApoliceSeguroIBPService from "@/core/api/ApoliceSeguroIBPService"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalModalApoliceSeguroIBPAdicionar from "@/core/components/Modals/ModalModalApoliceSeguroIBPAdicionar.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import ConfirmMixin from "@/core/mixins/confirm"
import LgFormInputNumber from "@/core/components/Form/LgFormInputNumber.vue";


export default {
    components: {
        ModalModalApoliceSeguroIBPAdicionar,
        LgFormInput,
        LgFormConstSelect,
        LgFormDate,
        LgFinderPageEmpresa,
        LgFormInputNumber

    },
    mixins: [FormResourceMixin, ListResourceMixin, ConfirmMixin],
    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Apólice Seguro",
        },

    },
    data() {
        return {
            mostrarModal: false,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            idApolice: null,
            form: {
                dtInicial: '',
                numero: null,
                empresa: { id: null },
                descricao: '',
                dtFinal: '',
                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            },
            itensFields: [
                {
                    key: 'numero', label: 'Nº Apólice',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'dataInicial', label: 'Data Final', formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'dataFinal', label: 'Data Inicial', formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'descricao', label: 'Descrição',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },
                {
                    key: 'razaoSocial', label: 'Fornecedor',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },

                {
                    key: 'editar', label: ' ', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'situacao', label: ' ', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

            ],
        };
    },
    watch: {
        page() {
            this.load();
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/apolice-seguro-ibp`);
        this.$apoliceSeguroIBPService = new ApoliceSeguroIBPService();
        this.load()

    },



    methods: {
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.APOLICE_SEGURO_EDITAR);
        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.APOLICE_SEGURO_INCLUIR);
        },

        mudarEmpresa(empresa) {
            this.form.empresa = empresa;
            this.load();

        },
        showModal() {
            this.mostrarModal = true;
        },
        fecharModal() {
            this.mostrarModal = false;
            this.idApolice = null;
            this.load();
        },
        editar(item) {
            this.idApolice = item.id;
            this.showModal();

        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Apólice Seguro?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

        async load() {

            this.params.dtInicial = null;
            this.params.dtFinal = null;
            this.params.id = this.id;
            this.params.descricao = null;
            this.params.empresa = null;
            this.params.situacao = null;
            this.params.numero = null;

            if (
                this.form.numero &&
                this.form.numero != ""
            ) {

                this.params.numero = this.form.numero;
            }

            if (this.form.dtInicial && this.form.dtFinal) {
                this.params.dtInicial = moment(String(this.form.dtInicial)).format(
                    "DD/MM/YYYY"
                );
                this.params.dtFinal = moment(String(this.form.dtFinal)).format(
                    "DD/MM/YYYY"
                );
            }

            if (this.form.descricao) {
                this.params.descricao = this.form.descricao;
            }

            if (this.form.situacao) {
                this.params.situacao = this.form.situacao;
            }

            if (this.form.empresa && this.form.empresa.id) {
                this.params.empresa.id = this.form.empresa.id;
            }


            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });

        },
        clearForm() {

            this.form = {
                dtInicial: '',
                numero: '',
                empresa: { id: null },
                descricao: '',
                dtFinal: '',
                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            };


        }
    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>